import styled from 'styled-components';

export const ReviewStars = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(0.5)};

  font-size: 1.6rem;
  line-height: 62.5%;
  color: ${({ theme }) => theme.palette.warning.main};
  fill: ${({ theme }) => theme.palette.warning.main};
`;
